export class UserStation {
  id: string;
  stationId: string;
  stationName: string;
  address: string;
  postcode: string;
  state: string;
  timestamp: Date;

  constructor(
    id: string,
    stationId: string,
    stationName: string,
    address: string,
    postcode: string,
    state: string,
    timestamp: Date
  ) {
    this.id = id;
    this.stationId = stationId;
    this.stationName = stationName;
    this.address = address;
    this.postcode = postcode;
    this.state = state;
    this.timestamp = timestamp;
  }
}
